import React, { useState } from 'react';
import Tool from '../Tool/Tool';
import { useGlobalVariablesContext } from '../../context/GlobalVariablesContext';
import { useTranslation } from 'react-i18next';
import TabNavigation from '../Bootstrap/Tabs/TabNavigation';
import TabContent from '../Bootstrap/Tabs/TabContent'; 
import ControlerLayerBase from './ControlerLayerBase';
import ControlerLayerOverlay from './ControlerLayerOverlay';


import './LayerSelector.css';



/**
 * LayerSelector: Componente que representa el selector de capas dentro de la aplicación.
 * Gestiona el estado de las pestañas activas y renderiza el contenido correspondiente
 * en el sidebar.
 * 
 * @author Eva Rabasco
 * @returns {JSX.Element} El componente que renderiza el selector de capas con las pestañas y su contenido.
 */
function LayerSelector() {
  const [activeTab, setActiveTab] = useState('listado'); // Estado para manejar la pestaña activa

  const { config } = useGlobalVariablesContext();
  const { t } = useTranslation();
  if (!config) return null

  const tabs = [
    { label: t('Layers'), value: 'listado' },
    { label: t('BaseMaps'), value: 'base' },
    // Puedes añadir más pestañas aquí
  ];

  const contents = [
    { value: 'listado', component: <ControlerLayerOverlay /> },
    { value: 'base', component: <ControlerLayerBase /> },
    // Puedes añadir más contenidos aquí
  ];

  // Contenido del Sidebar que se renderiza dentro del Tool
  const sidebarContent = (
    <div className="layer-selector-container">
      <TabNavigation activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} />
      <TabContent activeTab={activeTab} contents={contents} />
    </div>
  );

  return (
    <>
      {/* Herramienta que abre el sidebar con el contenido configurado */}
      <Tool
        id="layers"
        type="clickable"
        icon='bi bi-stack' 
        label={t('Layers')} 
        sidebarTitle={t('Layer Selector')} 
        hasSidebar
        sidebarContent={sidebarContent} 
      />
    </>
  );
}

export default LayerSelector;
